module.exports = __webpack_public_path__ + "media/images/konintodoke/konintodoke-banner-image-8af4d486560920e09d83b4956cc5ca64.jpg";